import { Injectable } from '@angular/core';

const AVAILABLE_COLORS: string[] = [
  '#a6dcef',
  '#c3aed6',
  '#dddddd',
  '#fafcc2',
  '#d6d2c4',
  '#bedbbb',
  '#fccbcb',
  '#9cada4',
  '#7e8a97',
  '#838383',
  '#e36387',
  '#f69e7b',
  '#8bcdcd',
  '#d8345f',
  '#f4eeff',
  '#dcd6f7'
];

@Injectable({
  providedIn: 'root'
})
export class TagColorService {

  toColorHash(value: string): string {
    return AVAILABLE_COLORS[Math.abs(TagColorService.hashCode(value) % 16)];
  }

  private static hashCode(value: string): number {
    const len = value.length;
    let hash = 0;
    let code;

    if (len === 0) {
      return hash;
    }

    for (let i = 0; i < len; i++) {
      code = value.charCodeAt(i);
      hash = ((hash << 5) - hash) + code;
      hash &= hash;
    }

    return hash;
  }

}
